import { Button, Typography } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React from 'react';
import { Link } from 'react-router-dom';
import { Box } from '../../UI';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import LiveHelpIcon from '@material-ui/icons/LiveHelp';
import EmailIcon from '@material-ui/icons/Email';

export default function NDA({ acceptedTerms, setIsOpen, match, description, id }) {
	const classes = useStyles();
	return (
		<ExpansionPanel style={{ marginTop: '1rem' }} defaultExpanded={true}>
			<ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
				<Typography variant="h6">
					<strong>Summary</strong>
				</Typography>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails>
				{!acceptedTerms ? (
					<>
						<Box style={{ overflow: 'hidden', width: '100%', height: '100%' }}>
							{description.map(string => (
								<Typography variant="body1" className={classes.blur}>
									{string}
								</Typography>
							))}
						</Box>
						<Button
							variant="contained"
							color="primary"
							style={{
								position: 'absolute',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%,-50%)',
							}}
							onClick={() => setIsOpen(true)}
						>
							aXcess NDA
						</Button>
					</>
				) : (
					<Box display="flex" flexDirection="column" height="100%">
						{description.map((string, index) => (
							<Typography key={index} variant="body1" style={{ marginBottom: '.5rem' }}>
								{string}
							</Typography>
						))}
						<Box display="flex" alignItems="center" width="100%" mt="2rem">
							<Button
								variant="contained"
								color="primary"
								style={{ marginRight: '1rem' }}
								component={Link}
								to={`${match.url}/analysis`}
								startIcon={<EqualizerIcon />}
							>
								Modelling/Analysis
							</Button>
							<Button
								variant="contained"
								color="primary"
								style={{ marginRight: '1rem' }}
								startIcon={<LiveHelpIcon />}
								component={Link}
								to={`${match.url}/qna`}
							>
								Q&A
							</Button>
							<Button
								variant="contained"
								color="primary"
								component={Link}
								to={`${match.url}/letter-of-intent`}
								startIcon={<EmailIcon />}
							>
								LoI
							</Button>
						</Box>
					</Box>
				)}
			</ExpansionPanelDetails>
		</ExpansionPanel>
	);
}

const useStyles = makeStyles(theme => ({
	paper: {
		width: '100%',
		padding: '15px',
		position: 'relative',
	},
	blur: {
		color: 'transparent',
		textShadow: '0 0 6px rgba(0, 0, 0, 0.8)',
		userSelect: 'none',
		'&:not(:last-child)': {
			marginBottom: '1rem',
		},
	},
}));
